export const quotesOptions = [
    {
        value: 1,
        label: `I truly believe that serving customers is one of the great
                factors that sets us apart from every other company.`,
    },
    {
        value: 2,
        label: `The most important mile in our business walk is the ”extra mile”,
                the one called service.`,
    },
    {
        value: 3,
        label: `Ours is a business where selling results from a truly personal
                one-on-one relationship - a friendship.`,
    },
] as const;
